import { pipe } from 'ramda';
import { setAction, setLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchAddPhoneEvent: DispatchEvent = pipe(
  setAction('add_phone'),
  dispatchFrontendDashboardEvent,
);

const dispatchAddPhoneOpenEvent: DispatchEvent = pipe(setLabel('open'), dispatchAddPhoneEvent);

const dispatchAddPhoneCloseEvent: DispatchEvent = pipe(setLabel('close'), dispatchAddPhoneEvent);

const dispatchAddPhoneGoBackEvent: DispatchEvent = pipe(setLabel('back'), dispatchAddPhoneEvent);

const dispatchAddPhoneNextStepEvent: DispatchEvent = pipe(
  setLabel('next_step'),
  dispatchAddPhoneEvent,
);

const dispatchAddPhoneExistingPhoneEvent: DispatchEvent = pipe(
  setLabel('existing_phone'),
  dispatchAddPhoneEvent,
);

const dispatchAddPhoneResendCodeEvent: DispatchEvent = pipe(
  setLabel('resend_code'),
  dispatchAddPhoneEvent,
);

const dispatchAddPhoneValidCodeEvent: DispatchEvent = pipe(
  setLabel('valid_code'),
  dispatchAddPhoneEvent,
);

const dispatchAddPhoneInvalidCodeEvent: DispatchEvent = pipe(
  setLabel('invalid_code'),
  dispatchAddPhoneEvent,
);

const dispatchAddPhoneRedirectEvent: DispatchEvent = pipe(
  setLabel('redirect_atwotk'),
  dispatchAddPhoneEvent,
);

export {
  dispatchAddPhoneOpenEvent,
  dispatchAddPhoneCloseEvent,
  dispatchAddPhoneGoBackEvent,
  dispatchAddPhoneNextStepEvent,
  dispatchAddPhoneExistingPhoneEvent,
  dispatchAddPhoneResendCodeEvent,
  dispatchAddPhoneValidCodeEvent,
  dispatchAddPhoneInvalidCodeEvent,
  dispatchAddPhoneRedirectEvent,
};
